<template>
  <div>
    <Title :pages="[{ icon: 'money-check', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-btn color="primary" class="mb-5" dark @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>

      <v-btn class="ml-3 mb-5 text-white" color="blue-grey" @click="dialog_bulk = true">Importar Cheques</v-btn>

      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <ModalBulk
        v-if="create_access"
        modal_title="Importar Cheques"
        :formBtn="formBtn"
        :service="service"
        :dialog="dialog_bulk"
        :mainItem="mainItem"
        @open="dialog_bulk = true"
        @close="dialog_bulk = false"
        @filter="loadList(service)"
      />

      <ModalChangeState :show="dialog_change_state" :modal_title="title_change_state" @refresh="filter" @close="dialog_change_state = false" :action="change_state_action" :cheques="selected" />

      <ModalRechazar :show="dialog_rechazar" :check="check_to_rechazar" @refresh="filter" @close="dialog_rechazar = false" />

      <ModalHistory @updateDialog="updateDialog" @loadList="loadList(service)" :show="dialog_history" @refresh="filter" @close="dialog_history = false" :check="check_history" />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" @reload="filter" />

      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                    clearable
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="check_number_select != null"
                        v-model="desde_selected"
                        label="Desde"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-menu ref="hasta_selected" v-model="hasta_selected_open" :close-on-content-click="false" min-width="auto" clearable>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :disabled="check_number_select != null"
                        v-model="hasta_selected"
                        label="Hasta"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        class="pt-0 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox class="pt-0 mt-0" v-model="state_selected" item-text="name" item-value="id" :items="states" label="Estado" clearable></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-combobox class="pt-0 mt-0" v-model="money_account_selected" item-text="name" item-value="id" :items="money_accounts" label="Cuenta" clearable></v-combobox>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field clearable v-model="check_number_select" autocomplete="off" class="pt-0 mt-0" label="Nº Cheque"></v-text-field>
                </div>

                <!--<div class="col-md-3 pt-0">
                  <v-combobox class="pt-0" v-model="fecha_tipo_selected" item-text="name" item-value="id" :items="fechas_tipo" label="Fecha de busqueda"></v-combobox>
                </div>-->

                <div class="col-md-3 pt-0">
                  <v-combobox class="pt-0" v-model="view_selected" item-text="name" item-value="id" :items="views" label="Mostrar" clearable></v-combobox>
                </div>
                <div class="col-md-6 pt-0" style="display: flex; justify-content: end">
                  <v-btn color="blue-grey" class="mr-2" dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <ModalHelp :show="dialog_help" @close="dialog_help = false" />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-btn icon small class="ml-2" @click="dialog_help = true" title="Ayuda">
            <v-icon color="amber darken-1">help_outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>

        <div class="mb-4" v-show="selected.length != 0 && update_access">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                style="border: 1px solid; border-radius: 100px; padding: 3px"
                color="blue-grey"
                :class="isActiveBlinking ? 'ml-3 button_blinking' : 'ml-3'"
                @click="toggleClass"
                v-bind="attrs"
                v-on="on"
              >
                more_vert
              </v-icon>
            </template>
            <v-list>
              <v-list-item dense @click="dialogChangeState('acreditar')">
                <v-list-item-title> Acreditar cheque</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="dialogChangeState('negotiate')">
                <v-list-item-title> Negociar cheque</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="dialogChangeState('cobrar_por_ventanilla')">
                <v-list-item-title> Cobrar cheque por ventanilla</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="dialogChangeState('debitar')">
                <v-list-item-title> Debitar cheque</v-list-item-title>
              </v-list-item>
              <v-list-item dense @click="dialogChangeState('depositar')">
                <v-list-item-title> Depositar cheque</v-list-item-title>
              </v-list-item>
              <!--
              <v-list-item dense @click="dialogChangeState('anular')">
                <v-list-item-title> Anular cheque</v-list-item-title>
              </v-list-item>
              -->
            </v-list>
          </v-menu>
        </div>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="{ item, isSelected, select }">
            <tr>
              <td>
                <v-checkbox :input-value="isSelected" style="margin: 0px; padding: 0px" hide-details @change="select($event)" />
              </td>
              <td>
                <div>{{ item.payment_date_str }}</div>
                <div class="text--secondary caption">{{ item.expiratino_date_str }}</div>
              </td>
              <td>
                <div>{{ item.is_own ? item.emitter.name : item.emitter_name }}</div>
                <div class="text--secondary caption">{{ item.bank != null ? item.bank.name : "-" }}</div>
              </td>
              <td>{{ item.number }}</td>
              <td class="text-right">{{ formatUtils.formatPrice(item.amount) }}</td>
              <td class="text-center">
                <span :class="getClassState(item.state)">{{ item.state }}</span>
              </td>
              <td>{{ item.observations }}</td>
              <td>
                <div class="no-wrap">{{ getPaymentDoc(item.charge_payment_method_label) }}</div>
                <div class="text--secondary caption">{{ getPaymentEntity(item.charge_payment_method_label) }}</div>
              </td>
              <td>
                <div class="no-wrap">{{ getPaymentDoc(item.spent_payment_method_label) }}</div>
                <div class="text--secondary caption">{{ getPaymentEntity(item.spent_payment_method_label) }}</div>
              </td>
              <td class="text-left px-0" style="width: 100px">
                <v-tooltip bottom v-if="item.money_account != null">
                  <template v-slot:activator="{ on }">
                    <v-icon small color="blue lighten-1" class="mr-2" v-on="on">info</v-icon>
                  </template>
                  <span>Cuenta actual: {{ item.money_account.name }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="grey" class="mr-2" @click="openHistory(item)"> timer </v-icon>
                  </template>
                  <span>Historial</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.state == ChequesState.STATE_EN_CARTERA">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="item.state == ChequesState.STATE_EN_CARTERA || item.state == ChequesState.STATE_SIN_IMPUTAR">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>

                <v-tooltip bottom v-if="(!item.is_own && item.state == ChequesState.STATE_ACREDITED) || item.state == ChequesState.STATE_UTILIZADO">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="orange darken-2" class="mr-2" @click="openRechazar(item)"> block </v-icon>
                  </template>
                  <span>Rechazar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import ChequesState from "@/constants/chequesStates";
import { checkService } from "@/libs/ws/checkService";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";

import Modal from "./Modal.vue";
import ModalChangeState from "./ModalChangeState.vue";
import ModalRechazar from "./ModalRechazar.vue";
import ModalHistory from "./ModalHistory.vue";
import ModalBulk from "./ModalBulk.vue";
import ModalHelp from "./ModalHelp.vue";
export default {
  components: { Title, Modal, ModalChangeState, ModalRechazar, ModalHistory, DialogDelete, ModalBulk, ModalHelp },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      dialog_change_state: false,
      dialog_rechazar: false,
      check_to_rechazar: null,
      dialog_help: false,
      dialog_bulk: false,
      isActiveBlinking: true,
      title_change_state: "",
      change_state_action: "",
      ChequesState: ChequesState,
      formatUtils: formatUtils,
      parent: this,
      service: checkService,
      page_title: "Cheques",
      modal_title: "Cheque",
      headers: [
        { text: "", align: "center", sortable: false, value: "" },
        {
          text: "Cobro / Vencimiento",
          align: "left",
          sortable: true,
          value: "payment_date",
        },
        {
          text: "Emisor / Banco",
          align: "left",
          sortable: true,
          value: "emitter.name",
        },
        {
          text: "Nro Cheque",
          align: "left",
          sortable: true,
          value: "number",
        },
        {
          text: "Importe",
          align: "right",
          sortable: true,
          value: "amount",
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "",
        },
        {
          text: "Observacion",
          align: "center",
          sortable: true,
          value: "observations",
        },
        {
          text: "Recibido",
          align: "center",
          sortable: true,
          value: "",
        },
        {
          text: "Utilizado",
          align: "center",
          sortable: true,
          value: "",
        },
        {
          text: "Acciones",
          align: "center",
        },
      ],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      list: [],
      dialog_delete: false,
      dialog_history: false,
      check_history: null,
      mainItem: {
        id: "",

        //NO propio
        emitter_name: "",

        //SI propio
        emitter: null,
        money_account: null,

        number: "",
        amount: "",
        emission_date: "",
        bank: null,
        payment_date: "",

        observations: null,
        state: null,

        is_own: false,
      },
      defaultItem: null,
      fechas_tipo: [
        { id: "payment_date", name: "Fecha de Cobro/Pago" },
        { id: "emission_date", name: "Fecha de Emisión" },
      ],
      fecha_tipo_selected: { id: "payment_date", name: "Fecha de Cobro/Pago" },
      view_selected: { id: null, name: "Propios y de terceros" },
      views: [
        { id: null, name: "Propios y de terceros" },
        { id: true, name: "Propios" },
        { id: false, name: "Terceros" },
      ],
      check_number_select: null,
      state_selected: null,
      states: [],
      money_account_selected: null,
      money_accounts: [],
    };
  },
  mounted() {
    this.loadList(this.service, this.getFilterParams());
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.getStates();
    this.getMoneyAccounts();
  },
  methods: {
    getPaymentDoc(label) {
      if (!label) return "-";
      const idx = label.lastIndexOf(" - ");
      return idx !== -1 ? label.substring(0, idx) : label;
    },
    getPaymentEntity(label) {
      if (!label) return "";
      const idx = label.lastIndexOf(" - ");
      return idx !== -1 ? label.substring(idx + 3) : "";
    },
    toggleClass() {
      this.isActiveBlinking = false;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .filter(param)
        .then((response) => {
          this.list = response.result;
          this.selected = [];
          this.loading = false;
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    getFilterParams() {
      const param = {
        date_type: this.fecha_tipo_selected != null ? this.fecha_tipo_selected.id : null,
        date_from: this.desde_selected + " 00:00:00",
        date_to: this.hasta_selected + " 23:59:59",
        state: this.state_selected ? this.state_selected.id : null,
        check_number: this.check_number_select,
        is_own: this.view_selected != null ? this.view_selected.id : null,
        money_account: this.money_account_selected ? this.money_account_selected.id : null,
      };
      return param;
    },
    openHistory(item) {
      this.check_history = item;
      this.dialog_history = true;
    },
    openRechazar(item) {
      this.check_to_rechazar = item;
      this.dialog_rechazar = true;
    },
    getClassState(state) {
      return checkService.getClassState(state);
    },
    dialogChangeState(action) {
      this.dialog_change_state = true;
      this.change_state_action = action;
      switch (action) {
        case "negotiate":
          this.title_change_state = "Negociar cheque";
          return;
        case "anular":
          this.title_change_state = "Anular cheque";
          return;
        case "acreditar":
          this.title_change_state = "Acreditar cheque";
          return;
        case "cobrar_por_ventanilla":
          this.title_change_state = "Cobrar cheque por ventanilla";
          return;
        case "debitar":
          this.title_change_state = "Debitar cheque";
          return;
        case "depositar":
          this.title_change_state = "Depositar cheque";
          return;
        case "rechazar":
          this.title_change_state = "Rechazar cheque";
          return;

        default:
          return "";
      }
    },
    getStates() {
      this.service
        .getStates()
        .then((response) => {
          this.states = response.result;
        })
        .catch((e) => {
          console.log("service.getStates error");
          console.log(e);
        });
    },
    getMoneyAccounts() {
      generalService
        .filter({ account_type: 'C', representa_fondos: true }, Constant.SECTION_MONEY_ACCOUNTS)
        .then((response) => {
          this.money_accounts = response.result;
        })
        .catch((e) => {
          console.log("generalService.filter money_accounts error", e);
        });
    },
    exportFile() {
      var param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_CHECKS + "/list", param, "Cheques.xlsx");
    },
    deleteItemConfirm() {
      this.loading = true;
      this.service
        .remove({ id: this.deleteId })
        .then((response) => {
          if (response.status === true) {
            this.$toast.success(response.msg, "OK");
            this.loadList(this.service, this.getFilterParams());
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.$toast.error("Error exception", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
      this.dialog_delete = false;
    },
  },
};
</script>
